import { formStep } from './formStep';
import { infoStep } from './infoStep';

export const videoTherapy = {
  namespaced: true,
  modules: {
    formStep,
    infoStep
  }
};
